import get from "lodash/get";

export const dateComparator = (field, direction = "asc") => (a, b) => {
  const dateA = new Date(get(a, field)).getTime();
  const dateB = new Date(get(b, field)).getTime();

  if (direction === "asc") return dateA - dateB;
  else if (direction === "desc") return dateB - dateA;
  else console.error("Sort direction is not recognized: ", direction);
};



// WEBPACK FOOTER //
// ./src/utils/sorters.js